<template>
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.3898 0.560013C25.2034 1.3067 25.2034 2.51731 24.3898 3.26399L8.33333 18L0.610194 10.912C-0.203398 10.1653 -0.203398 8.95471 0.610194 8.20802C1.42379 7.46134 2.74288 7.46134 3.55647 8.20802L8.33333 12.592L21.4435 0.560013C22.2571 -0.186671 23.5762 -0.186671 24.3898 0.560013Z"
      fill="white"
    />
  </svg>
</template>

<style lang="scss" scoped>
.item-checkbox svg {
  width: 12px;
  height: 8px;
}
</style>
